var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreAwards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 198,
    viewBox: "0 0 315 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5553_265594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.559 40H98.5197C66.1875 40 39.9999 66.1876 39.9999 98.5198C39.9999 130.852 66.1875 157.04 98.5197 157.04C114.905 157.04 129.682 150.31 140.288 139.484H173.754C184.361 150.31 199.174 157.04 215.523 157.04C247.855 157.04 274.043 130.852 274.043 98.5198C274.043 66.1876 247.892 40 215.559 40ZM133.632 105.835C133.632 108.249 131.657 110.224 129.243 110.224H110.224V129.243C110.224 131.657 108.249 133.632 105.835 133.632H91.2048C88.7908 133.632 86.8158 131.657 86.8158 129.243V110.224H67.7968C65.3829 110.224 63.4079 108.249 63.4079 105.835V91.2048C63.4079 88.7909 65.3829 86.8158 67.7968 86.8158H86.8158V67.7969C86.8158 65.383 88.7908 63.4079 91.2048 63.4079H105.835C108.249 63.4079 110.224 65.383 110.224 67.7969V86.8158H129.243C131.657 86.8158 133.632 88.7909 133.632 91.2048V105.835ZM200.929 130.706C191.237 130.706 183.373 122.842 183.373 113.15C183.373 103.457 191.237 95.5938 200.929 95.5938C210.622 95.5938 218.485 103.457 218.485 113.15C218.485 122.842 210.622 130.706 200.929 130.706ZM230.189 101.446C220.497 101.446 212.633 93.5822 212.633 83.8899C212.633 74.1975 220.497 66.3339 230.189 66.3339C239.882 66.3339 247.745 74.1975 247.745 83.8899C247.745 93.5822 239.882 101.446 230.189 101.446Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5553_265594",
    x: -0.0000610352,
    y: 0,
    width: 314.043,
    height: 197.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5553_265594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5553_265594",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreAwards);
export default __webpack_public_path__ + "static/media/more-awards.319aa7c5ee2a0f4b1c2e8a839f391617.svg";
export { ForwardRef as ReactComponent };